module.exports = __webpack_public_path__ + "img/airport-door.29b81b84.png";